import { render } from "./LogIn.vue?vue&type=template&id=532f8f79"
import script from "./LogIn.vue?vue&type=script&lang=js"
export * from "./LogIn.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__